module.exports = __webpack_public_path__ + "img/prev_sicur_disabled.abb8979e.png";